module.exports = __webpack_public_path__ + "img/電気回路_4_7_2.cb3e9160.png";